import React from 'react';
import { Box, StatusIndicator } from '@amzn/awsui-components-react';
import './DerivedAllocationSheet.scss';

/** A step's guidance under its header, shown as an info line. */
export default function DasStepInfo({ children }: { children: React.ReactNode }) {
    return (
        <div data-class="dasStepInfo" className="dasStepInfo">
            <StatusIndicator type="info" wrapText><Box variant="small" color="inherit">{children}</Box></StatusIndicator>
        </div>
    );
}
